import { render, staticRenderFns } from "./PortfolioView.vue?vue&type=template&id=5d479e99&scoped=true&"
import script from "./PortfolioView.vue?vue&type=script&scoped=true&lang=js&"
export * from "./PortfolioView.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./PortfolioView.vue?vue&type=style&index=0&id=5d479e99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d479e99",
  null
  
)

export default component.exports